import type { ScoreResponse } from "@/types/score"
import client from "./client"

export async function getScores(code: string): Promise<ScoreResponse> {
  const { data } = await client.get<ScoreResponse>(`/api/scores/${code}`)
  return data
}
